"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = exports.MenuSection = exports.Menu = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var menu_1 = require("@react-aria/menu");

var tree_1 = require("@react-stately/tree");

var interactions_1 = require("@react-aria/interactions");

var utils_1 = require("@react-aria/utils");

var components_utils_1 = require("@conte-ltd/components-utils");

var components_collection_1 = require("@conte-ltd/components-collection");

var components_collapse_1 = require("@conte-ltd/components-collapse");

function _Menu(props, fwRef) {
  var collapsable = props.collapsable,
      isExclusive = props.isExclusive;
  var ref = (0, react_2.useRef)(null);
  var state = (0, tree_1.useTreeState)(__assign({
    selectionMode: 'none'
  }, props));
  var menuProps = (0, menu_1.useMenu)(props, state, ref).menuProps;
  return (0, jsx_runtime_1.jsx)("ul", __assign({
    ref: (0, components_utils_1.mergeRefs)([ref, fwRef])
  }, (0, utils_1.mergeProps)(menuProps, (0, components_utils_1.styleProps)(props)), {
    children: (0, react_2.useMemo)(function () {
      return __spreadArray([], __read(state.collection), false).map(function (node) {
        var key = node.key,
            type = node.type,
            props = node.props;
        return (0, jsx_runtime_1.jsx)(components_collection_1.TreeProvider, __assign({
          state: state,
          node: node,
          collapsable: collapsable,
          isExclusive: isExclusive
        }, {
          children: type === 'item' ? (0, jsx_runtime_1.jsx)(_MenuItem, __assign({}, props), void 0) : type === 'section' ? (0, jsx_runtime_1.jsx)(_MenuSection, __assign({}, props), void 0) : null
        }), key);
      });
    }, [state, collapsable, isExclusive])
  }), void 0);
}

exports.Menu = (0, react_2.forwardRef)(_Menu);

function _MenuSection(props) {
  var onAction = props.onAction,
      propCollapsable = props.collapsable;
  var ref = (0, react_2.useRef)(null);

  var _a = (0, menu_1.useMenuSection)(props),
      itemProps = _a.itemProps,
      headingProps = _a.headingProps,
      groupProps = _a.groupProps;

  var context = (0, components_collection_1.useTreeContext)();

  var _b = (0, components_collection_1.useTreeNode)(context),
      isExpanded = _b.isExpanded,
      onToggle = _b.onToggle;

  var pressProps = (0, interactions_1.usePress)({
    onPress: onToggle
  }).pressProps;
  var node = context.node,
      _c = context.collapsable,
      collapsable = _c === void 0 ? propCollapsable : _c;
  var _d = node,
      rendered = _d.rendered,
      childNodes = _d.childNodes;

  var children = __spreadArray([], __read(childNodes), false);

  var childrenRendered = (0, react_2.useMemo)(function () {
    return children.map(function (node) {
      var key = node.key,
          type = node.type,
          props = node.props;
      return (0, jsx_runtime_1.jsx)(components_collection_1.TreeProvider, __assign({
        node: node
      }, {
        children: type === 'item' ? (0, jsx_runtime_1.jsx)(_MenuItem, __assign({
          onAction: onAction
        }, props), void 0) : type === 'section' ? (0, jsx_runtime_1.jsx)(_MenuSection, __assign({
          onAction: onAction
        }, props), void 0) : null
      }), key);
    });
  }, [children]);
  return (0, jsx_runtime_1.jsxs)("li", __assign({
    ref: ref
  }, (0, utils_1.mergeProps)(itemProps, (0, components_utils_1.styleProps)(props)), {
    children: [(0, react_2.isValidElement)(rendered) ? (0, react_2.cloneElement)(rendered, __assign({}, (0, utils_1.mergeProps)(headingProps, pressProps))) : (0, jsx_runtime_1.jsx)("div", __assign({}, (0, utils_1.mergeProps)(headingProps, pressProps), {
      children: rendered
    }), void 0), collapsable ? (0, jsx_runtime_1.jsx)(components_collapse_1.Collapse, __assign({
      isExpanded: isExpanded
    }, {
      children: (0, jsx_runtime_1.jsx)("ul", __assign({}, groupProps, {
        children: childrenRendered
      }), void 0)
    }), void 0) : (0, jsx_runtime_1.jsx)("ul", __assign({}, groupProps, {
      children: childrenRendered
    }), void 0)]
  }), void 0);
}

exports.MenuSection = components_collection_1.Section;

function _MenuItem(props) {
  var _a = (0, components_collection_1.useTreeContext)(),
      state = _a.state,
      node = _a.node;

  var ref = (0, react_2.useRef)(null);
  var menuItemProps = (0, menu_1.useMenuItem)(__assign({
    key: node.key
  }, props), state, ref).menuItemProps;
  return (0, jsx_runtime_1.jsx)("li", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        outline: 0;\n      "], ["\n        outline: 0;\n      "]))),
    ref: ref
  }, (0, utils_1.mergeProps)(menuItemProps, (0, components_utils_1.styleProps)(props)), {
    children: node.rendered
  }), void 0);
}

exports.MenuItem = components_collection_1.Item;
var templateObject_1;